import { render, staticRenderFns } from "./DocumentsUpload.vue?vue&type=template&id=ce3b553e&scoped=true&"
import script from "./DocumentsUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentsUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsUpload.vue?vue&type=style&index=0&id=ce3b553e&scoped=true&lang=css&"
import style1 from "./DocumentsUpload.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3b553e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VDivider,VIcon,VRow})
